import React from 'react';
import '../../styles/admin/StatsSummary.css';

const StatsSummary = ({ stats }) => {
  const cards = [
    {
      title: 'Total Products',
      value: stats.totalProducts || 0,
      icon: 'fas fa-box',
      color: '#3b82f6',
      bgColor: '#dbeafe'
    },
    {
      title: 'Total Sales',
      value: `LKR ${(stats.totalSales || 0).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`,
      icon: 'fas fa-chart-line',
      color: '#10b981',
      bgColor: '#d1fae5'
    },
    {
      title: 'Low Stock Items',
      value: stats.lowStockCount || 0,
      icon: 'fas fa-exclamation-triangle',
      color: '#f59e0b',
      bgColor: '#fef3c7'
    },
    {
      title: 'Total Invoices',
      value: stats.totalInvoices || 0,
      icon: 'fas fa-receipt',
      color: '#8b5cf6',
      bgColor: '#ede9fe'
    }
  ];

  return (
    <div className="stats-summary">
      {cards.map((card, index) => (
        <div key={index} className="stat-card" style={{ borderColor: card.color }}>
          <div className="stat-icon" style={{ backgroundColor: card.bgColor, color: card.color }}>
            <i className={card.icon}></i>
          </div>
          <div className="stat-content">
            <h3>{card.title}</h3>
            <p className="stat-value" style={{ color: card.color }}>{card.value}</p>
          </div>
        </div>
      ))}
    </div>
  );
};

export default StatsSummary;